import React from 'react';
import { Component } from "react";


export default class SolicitacaoHistoricoRegistro extends Component {
  render() {
    return <ul><li>Criou a tarefa</li></ul>
    
    // return <SolicitacaoAtividade>
    //   <ul>
    //     <li>Criou a tarefa</li>
    //   </ul>
    // </SolicitacaoAtividade>
  }
}
